const KPRF = {
    autoInitComponents: true,
    components: {}
}

KPRF.components.featuredScroll = {
    selector: ".js-featured-scroll",
    containers: [],
    inputs: [],
    items: [],
    init: function () {
        document.querySelectorAll(this.selector).forEach(this.apply);
    },
    apply: function (element) {
        const component = KPRF.components.featuredScroll;
        const container = {
            block: element,
            figure: element.querySelector("figure"),
            link: element.querySelector("figure a"),
            image: element.querySelector("figure img"),
            list: element.querySelector("ul")
        }
        const index = component.containers.length;
        container.list.querySelectorAll("input").forEach(function (radio) {
            radio.dataset.container = index;
            component.inputs.push(radio);
            radio.addEventListener("click", component.handleClick);
        });
        container.list.querySelectorAll("li").forEach(function (item) {
            component.items.push(item);
            item.addEventListener("mouseover", component.handleMouseOver);
        });

        component.containers.push(container);
        container.list.querySelector("li:first-of-type input").click();
    },
    handleMouseOver: function (event) {
        const item = event.target.closest("li");
        const input = item.querySelector("input");
        input.click();
    },
    handleClick: function (event) {
        const component = KPRF.components.featuredScroll;
        const input = event.target;
        component.show(input.dataset.container, input.dataset.index);
    },
    show: function (containerIndex, elementIndex) {
        const component = KPRF.components.featuredScroll;
        const container = component.containers[containerIndex];
        if (container) {
            const input = container.list.querySelector(`input[data-index="${elementIndex}"]`);
            if (input) {
                if (input.checked) {
                    container.image.src = input.value;
                    container.link.href = input.closest("li").querySelector("a").href;
                } else {
                    input.click();
                }
            }
        }
    }
}

window.KPRF = KPRF;

Biovision.components.KPRF = KPRF;